/* ===================================================
   GUMMAH — Main JS
   =================================================== */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Sticky Nav ──────────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ── Hamburger / Mobile Menu ─────────────────── */
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Reveal on Scroll ────────────────────────── */
  const revealEls = document.querySelectorAll('.reveal, .reveal--left, .reveal--right, .reveal--scale');
  if (revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(el => io.observe(el));
  }

  /* ── USP Ticker — duplicate for seamless loop ── */
  const ticker = document.querySelector('.usp-strip__track');
  if (ticker) {
    ticker.innerHTML += ticker.innerHTML;
  }

  /* ── Quote Marquee — duplicate ───────────────── */
  const quoteTrack = document.querySelector('.quote-track');
  if (quoteTrack) {
    quoteTrack.innerHTML += quoteTrack.innerHTML;
  }

  /* ── Counter Animation ───────────────────────── */
  const statEls = document.querySelectorAll('.stat__value[data-target]');
  if (statEls.length) {
    const counterIO = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          animateCounter(e.target);
          counterIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    statEls.forEach(el => counterIO.observe(el));
  }

  function animateCounter(el) {
    const target = parseFloat(el.dataset.target);
    const suffix = el.dataset.suffix || '';
    const prefix = el.dataset.prefix || '';
    const decimals = el.dataset.decimals ? parseInt(el.dataset.decimals) : 0;
    const duration = 1800;
    const start = performance.now();
    const ease = t => 1 - Math.pow(1 - t, 4);

    requestAnimationFrame(function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const val = target * ease(progress);
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    });
  }

  /* ── Hero Parallax ───────────────────────────── */
  const heroBg = document.querySelector('.hero__bg');
  if (heroBg && window.innerWidth > 768) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      heroBg.style.transform = `translateY(${y * 0.3}px)`;
    }, { passive: true });
  }

  /* ── Lifestyle Strip — duplicate for seamless loop ── */
  const lifeTrack = document.querySelector('.lifestyle-strip__track');
  if (lifeTrack) {
    lifeTrack.innerHTML += lifeTrack.innerHTML;
  }

  /* ── Smooth section links ────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (!href || href === '#') return;
      let target = null;
      try { target = document.querySelector(href); } catch (_) {}
      if (target) {
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});

/* ── AJAX Add to Cart ────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-cart-btn]');
      const feedback = form.querySelector('.cart-feedback');
      const variantId = form.querySelector('[name="id"]').value;
      if (!variantId) return;

      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = 'Added to Cart';
          if (feedback) { feedback.textContent = 'Added to cart.'; feedback.classList.add('show'); feedback.classList.remove('error'); }
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
            if (feedback) feedback.classList.remove('show');
          }, 2500);
        } else {
          throw new Error('failed');
        }
      } catch (_) {
        btn.textContent = originalText;
        btn.disabled = false;
        if (feedback) { feedback.textContent = 'Something went wrong. Please try again.'; feedback.classList.add('show', 'error'); }
      }
    });
  });

  /* Variant selector — update price display */
  document.querySelectorAll('.variant-select').forEach(select => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const priceEl = form && form.querySelector('[data-variant-price]');
      const opt = select.options[select.selectedIndex];
      if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      const hiddenId = form && form.querySelector('[name="id"]');
      if (hiddenId) hiddenId.value = select.value;
    });
  });

  /* ── FAQ Accordion ─────────────────────────────── */
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const isOpen = item.classList.contains('open');

      /* Close all others */
      document.querySelectorAll('.faq-item.open').forEach(open => {
        if (open !== item) {
          open.classList.remove('open');
          open.querySelector('.faq-answer').style.maxHeight = '0';
          const b = open.querySelector('.faq-question');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });

      item.classList.toggle('open', !isOpen);
      answer.style.maxHeight = isOpen ? '0' : answer.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

});

/* ─────────────────────────────────────────────────────────────
   GLOBAL SIGNUP GUARD
   One capture-phase submit handler for every native signup form
   (homepage waitlist + /pages/signup). Blocks empty / invalid
   emails (rejects a@b) and honeypot bots BEFORE the browser
   submits, so nothing reaches the captcha with bad data.
   Quiz + scratch forms self-validate (AJAX) and are skipped.
   ───────────────────────────────────────────────────────────── */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* ---- Klaviyo capture (shared by waitlist, quiz and scratch) ----
     Uses Klaviyo's client subscribe endpoint: no server, no Shopify
     captcha, no redirect. Falls back to the native form if unset. */
  var K = (window.GUMMAH || {}).klaviyo || {};
  window.gummahKlaviyo = {
    /* configured() needs the public key; each form supplies its own list id. */
    configured: function (listId) { return !!(K.key && (listId || K.list)); },
    subscribe: function (email, firstName, props, listId) {
      var lid = listId || K.list;
      var attrs = { email: email };
      if (firstName) attrs.first_name = firstName;
      if (props) attrs.properties = props;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K.key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: attrs } } },
            relationships: { list: { data: { type: 'list', id: lid } } }
          }
        })
      });
    }
  };

  function isNativeSignup(form) {
    if (!form || typeof form.querySelector !== 'function') return false;
    if (!form.querySelector('input[type="email"]')) return false;
    /* Only OUR signup forms carry the honeypot. Anything with a message box
       (contact form, blog comments) is not a signup and must submit natively. */
    if (!form.querySelector('.hp-field')) return false;
    if (form.querySelector('textarea')) return false;
    return !(form.closest('[data-quiz-root]') || form.closest('.scratch-overlay'));
  }

  /* Turn off native validation so branded errors show for empty fields too. */
  function markForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (isNativeSignup(forms[i])) forms[i].setAttribute('novalidate', 'novalidate');
    }
  }
  if (document.readyState !== 'loading') markForms();
  else document.addEventListener('DOMContentLoaded', markForms);

  function showError(form, email, msg, focusEl) {
    var box = form.querySelector('[data-waitlist-error], [data-sl-error], [data-signup-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-signup-error', '');
      box.style.cssText = 'color:#9a2f24;font-size:0.85rem;margin:0.5rem 0 0;';
      var anchor = (focusEl || email);
      if (anchor && anchor.parentNode) anchor.parentNode.appendChild(box);
      else form.appendChild(box);
    }
    box.hidden = false; box.style.display = 'block'; box.textContent = msg;
    if (focusEl) { try { focusEl.focus(); } catch (e) {} }
  }

  function showSuccess(form) {
    var card = form.closest('.email-form-card, .sl-card') || form.parentNode;
    var kids = card.children;
    for (var i = 0; i < kids.length; i++) kids[i].style.display = 'none';
    var s = document.createElement('div');
    s.className = 'signup-success-js';
    s.innerHTML = '<div class="signup-success-js__title">You’re in.</div>' +
      '<p class="signup-success-js__body">You’re on the waitlist. Check your inbox; your free creatine guide is on its way.</p>';
    card.appendChild(s);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isNativeSignup(form)) return;
    var email = form.querySelector('input[type="email"]');
    var hp = form.querySelector('.hp-field');
    var name = form.querySelector('input[name="contact[name]"], input[name="contact[first_name]"]');

    if (hp && hp.value) { e.preventDefault(); e.stopPropagation(); return; }
    if (name && name.value.trim().length < 2) { e.preventDefault(); e.stopPropagation(); return showError(form, email, 'Please enter your first name.', name); }
    if (!EMAIL_RE.test(email.value.trim())) { e.preventDefault(); e.stopPropagation(); return showError(form, email, 'Please enter a valid email address.', email); }

    /* Valid. If Klaviyo is connected, capture there (no captcha, no redirect). */
    var listEl = form.closest('[data-klaviyo-list]');
    var listId = listEl ? listEl.getAttribute('data-klaviyo-list') : '';
    if (window.gummahKlaviyo.configured(listId)) {
      e.preventDefault(); e.stopPropagation();
      var btn = form.querySelector('button[type="submit"], .form-submit-btn, .sl-submit');
      if (btn) { btn.disabled = true; btn.dataset.lbl = btn.textContent; btn.textContent = 'Joining…'; }
      var props = { signup_source: 'waitlist' };
      var tagsEl = form.querySelector('input[name="contact[tags]"]');
      if (tagsEl && tagsEl.value) props.tags = tagsEl.value;
      window.gummahKlaviyo.subscribe(email.value.trim(), name ? name.value.trim() : '', props, listId)
        .then(function (r) { if (r && r.ok) { showSuccess(form); } else { throw new Error('bad'); } })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.lbl || 'Join the Waitlist'; }
          showError(form, email, 'Something went wrong. Please try again.');
        });
    }
    /* else: no Klaviyo → native Shopify submit proceeds (captcha path). */
  }, true);
})();
